<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/classification/inspection/standards/item/page"
      getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item class="noborder" :label="$t('jianyanbiaozhunmingcheng')">
            <el-input disabled v-model="$attrs.standards.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('jianyanleixing')" class="noborder">
            <el-input disabled
              :value="$t(store.state.dictJson['QUALITY_INSPECTION_TYPE'][$attrs.standards.inspectionType])"></el-input>
          </el-form-item>
          <el-form-item :label="$t('jianyanfenlei')" class="noborder">
            <el-input disabled
              :value="$t(store.state.dictJson['INSPECTION_CLASSIFICATION'][$attrs.standards.inspectionClassification])"></el-input>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('fenleijianyanbiaozhunbanben')">
            <el-input disabled v-model="$attrs.standards.version"></el-input>
          </el-form-item>
          <el-form-item>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button v-if="utils.checkPower('web_quality_management_classification_inspection_standards_item_create')" size="mini" @click="yt.showEditDialog('xinzeng', null, 'w1'); getInspectionList()" type="primary">
          {{ $t('xinzeng') }}
        </el-button>
        <el-button v-if="utils.checkPower('web_quality_management_classification_inspection_standards_item_import')" size="mini" @click="show = !show" plain>
          {{ $t('daoru') }}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')"
          @click="yt.showColumnsDialog()"></el-button>
      </template>
      <template #chouyangguocheng="scope">
        <span
          v-if="scope.row.samplingProcedure">{{ scope.row.samplingProcedure.code }}/{{ scope.row.samplingProcedure.desc }}</span>
      </template>
      <!--检验标识-->
      <template #jianyanbiaoshi="scope">
        <el-input disabled
              :value="$t(store.state.dictJson['QUALITY_INSPECTION_STANDARD_FLAG'][$attrs.standards.inspectionClassification])"></el-input>
      </template>
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button v-if="utils.checkPower('web_quality_management_classification_inspection_standards_item_update')" type="text" @click="yt.showEditDialog('bianji', scope.row); getInspectionList()">{{ $t('bianji') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button v-if="utils.checkPower('web_quality_management_classification_inspection_standards_item_delete')" type="text" class="font-color-danger"
              @click="yt.remove(scope.row, '/web/classification/inspection/standards/item/delete')">
              {{ $t('shanchu') }}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
      :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <div class="dialog-scroller">
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <el-form-item :label="$t('gongxu')" required>
              <el-input v-model="yt.editObj.procedure"></el-input>
            </el-form-item>
            <el-form-item :label="$t('jianyanleibie')" required>
              <el-input v-model="yt.editObj.inspectionCategory"></el-input>
            </el-form-item>
            <el-form-item :label="$t('jianyanxiangmu')" required>
              <el-input v-model="yt.editObj.inspectionProject"></el-input>
            </el-form-item>
            <el-form-item :label="$t('jianyangongju')" required>
              <el-input v-model="yt.editObj.inspectionTools"></el-input>
            </el-form-item>
            <el-form-item :label="$t('jianyanbiaoshi')" required>
              <yi_dictionary_select :type="'QUALITY_INSPECTION_STANDARD_FLAG'" :ids.sync="yt.editObj.inspectionMark">
            </yi_dictionary_select>
            </el-form-item>
            <el-form-item :label="$t('jianyanfangshi')" required>
              <el-select :max="1" filterable :clearable="true" v-model="yt.editObj.inspectionMethodId">
                <el-option v-for="(item, index) in typeList" :key="index" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('shifoubijian')" required>
              <el-select v-model="yt.editObj.must" clearable>
                <el-option :label="$t('shi')" :value="1"></el-option>
                <el-option :label="$t('fou')" :value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('jianyanyiju')">
              <el-input v-model="yt.editObj.inspectionAccording"></el-input>
            </el-form-item>
            <el-form-item :label="$t('quexiandengji')">
              <el-input v-model="yt.editObj.defectLevel"></el-input>
            </el-form-item>
            <div v-if="yt.editObj.inspectionMark === '1'">
              <el-form-item :label="$t('chouyangguocheng')" required>
                <yi_cross_select :max="1" :selectTitle="'code,desc'"
                  :component="'web_quality_management_sampling_procedure_list'"
                  :ids.sync="yt.editObj.samplingProcedureId">
                </yi_cross_select>
              </el-form-item>
              <el-form-item :label="$t('guigexiaxian')">
                  <yi_number_input :precision="5" :start.sync="yt.editObj.specLowerLimit" :type="'number'"></yi_number_input>
							</yi_number_input>
              </el-form-item>
              <el-form-item :label="$t('guigeshangxian')">
                  <yi_number_input :precision="5" :start.sync="yt.editObj.specUpLimit" :type="'number'"></yi_number_input>
              </el-form-item>
              <el-form-item :label="$t('jiliangdanwei')">
                <el-input v-model="yt.editObj.measurementUnit"></el-input>
              </el-form-item>
            </div>
            <div v-else-if="yt.editObj.inspectionMark === '2'">
              <el-form-item :label="$t('chouyangguocheng')" required>
                <yi_cross_select :max="1" :selectTitle="'code,desc'"
                  :component="'web_quality_management_sampling_procedure_list'"
                  :ids.sync="yt.editObj.samplingProcedureId">
                </yi_cross_select>
              </el-form-item>
              <el-form-item :label="$t('guigexiaxian')" required>
                <yi_number_input :precision="5" :start.sync="yt.editObj.specLowerLimit" :type="'number'"></yi_number_input>
              </el-form-item>
              <el-form-item :label="$t('guigeshangxian')" required>
                <!-- <el-input v-model="yt.editObj.specUpLimit"></el-input> -->
                <yi_number_input :precision="5" :start.sync="yt.editObj.specUpLimit" :type="'number'"></yi_number_input>
              </el-form-item>
              <el-form-item :label="$t('jiliangdanwei')" required>
                <el-input v-model="yt.editObj.measurementUnit"></el-input>
              </el-form-item>
            </div>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini"
            @click="yt.req('POST', '/web/classification/inspection/standards/item/create', beforeAdd)" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- 编辑 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <div class="dialog-scroller">
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <el-form-item :label="$t('gongxu')" required>
              <el-input v-model="yt.editObj.procedure"></el-input>
            </el-form-item>
            <el-form-item :label="$t('jianyanleibie')" required>
              <el-input v-model="yt.editObj.inspectionCategory"></el-input>
            </el-form-item>
            <el-form-item :label="$t('jianyanxiangmu')" required>
              <el-input v-model="yt.editObj.inspectionProject"></el-input>
            </el-form-item>
            <el-form-item :label="$t('jianyangongju')" required>
              <el-input v-model="yt.editObj.inspectionTools"></el-input>
            </el-form-item>
            <el-form-item :label="$t('jianyanbiaoshi')" required>
              <yi_dictionary_select :type="'QUALITY_INSPECTION_STANDARD_FLAG'" :ids.sync="yt.editObj.inspectionMark">
            </yi_dictionary_select>
            </el-form-item>
            <el-form-item :label="$t('jianyanfangshi')" required>
              <el-select :max="1" filterable :clearable="true" v-model="yt.editObj.inspectionMethodId">
                <el-option v-for="(item, index) in typeList" :key="index" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('shifoubijian')" required>
              <el-select v-model="yt.editObj.must" clearable>
                <el-option :label="$t('shi')" :value="1"></el-option>
                <el-option :label="$t('fou')" :value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('jianyanyiju')">
              <el-input v-model="yt.editObj.inspectionAccording"></el-input>
            </el-form-item>
            <el-form-item :label="$t('quexiandengji')">
              <el-input v-model="yt.editObj.defectLevel"></el-input>
            </el-form-item>
            <div v-if="yt.editObj.inspectionMark === '1'">
              <el-form-item :label="$t('chouyangguocheng')" required>
                <yi_cross_select :max="1" :selectTitle="'code,desc'"
                  :component="'web_quality_management_sampling_procedure_list'"
                  :ids.sync="yt.editObj.samplingProcedureId">
                </yi_cross_select>
              </el-form-item>
              <el-form-item :label="$t('guigexiaxian')">
                <yi_number_input :precision="5" :start.sync="yt.editObj.specLowerLimit" :type="'number'"></yi_number_input>
              </el-form-item>
              <el-form-item :label="$t('guigeshangxian')">
                <yi_number_input :precision="5" :start.sync="yt.editObj.specUpLimit" :type="'number'"></yi_number_input>
              </el-form-item>
              <el-form-item :label="$t('jiliangdanwei')">
                <el-input v-model="yt.editObj.measurementUnit"></el-input>
              </el-form-item>
            </div>
            <div v-else-if="yt.editObj.inspectionMark === '2'">
              <el-form-item :label="$t('chouyangguocheng')" required>
                <yi_cross_select :max="1" :selectTitle="'code,desc'"
                  :component="'web_quality_management_sampling_procedure_list'"
                  :ids.sync="yt.editObj.samplingProcedureId">
                </yi_cross_select>
              </el-form-item>
              <el-form-item :label="$t('guigexiaxian')" required>
                <yi_number_input :precision="5" :start.sync="yt.editObj.specLowerLimit" :type="'number'"></yi_number_input>
              </el-form-item>
              <el-form-item :label="$t('guigeshangxian')" required>
                <yi_number_input :precision="5" :start.sync="yt.editObj.specUpLimit" :type="'number'"></yi_number_input>
              </el-form-item>
              <el-form-item :label="$t('jiliangdanwei')" required>
                <el-input v-model="yt.editObj.measurementUnit"></el-input>
              </el-form-item>
            </div>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini"
            @click="yt.req('POST', '/web/classification/inspection/standards/item/update')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
    <!-- 导入excel -->
    <import-excel :show.sync="show" :inspectionStandardsId="$attrs.standards.id" />
  </div>
</template>
<script type="text/javascript">
import importExcel from './import_excel'

export default {
  name: 'web_quality_management_inspection_standard_standards_item',
  components: {
    importExcel
  },
  data() {
    return {
      show: false,
      typeList: [],
      columns: [{
        label: 'gongxu',
        prop: 'procedure',
      }, {
        label: 'jianyanleibie',
        prop: 'inspectionCategory',
        width: 130,
      }, {
        label: 'jianyanxiangmu',
        prop: 'inspectionProject',
        width: 180,
      }, {
        label: 'jianyangongju',
        prop: 'inspectionTools',
        width: 130,
        // format: 'yyyy-MM-dd:hh:mm:ss'
      },
      {
          label: 'jianyanbiaoshi',
          prop: 'inspectionMark',
          type: 'dictionary',
          key: 'QUALITY_INSPECTION_STANDARD_FLAG',
          width: 150
      },
      {
        label: 'jianyanfangshi',
        prop: 'inspectionMethod.name',
        width: 180,
      },
      {
        label: 'shifoubijian',
        prop: 'must',
        type: 'bool',
        iln18: ['shi', 'fou'],
      },
      {
        label: 'jianyanyiju',
        prop: 'inspectionAccording',
        width: 180,
      },
      {
        label: 'quexiandengji',
        prop: 'defectLevel',
        width: 180,
      },
      {
        label: 'chouyangguocheng',
        type: 'slot',
        width: 180,
      },
      {
        label: 'guigexiaxian',
        prop: 'specLowerLimit',
        width: 180,
      }, {
        label: 'guigeshangxian',
        prop: 'specUpLimit',
        width: 180,
      }, {
        label: 'jiliangdanwei',
        prop: 'measurementUnit',
        width: 180,
      }, {
        label: 'caozuo',
        type: 'slot',
        width: 150,
        fixed: 'right'
      }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = {
        inspectionStandardsId: this.$attrs.standards.id,
      }
      this.yt.get(1);
      this.utils.event_hub.$on('STANDARDS_ITEM_REFRESH', () => {
        this.yt.get(1);
      })
    }, 300)
  },

  methods: {
    async getInspectionList() {
      this.showTab = false
      return await this.http.get('/web/quality/inspection/method/list?' + this.qs.stringify({
        // pageNum: 1,
        // pageSize: 99999,
        inspectionType: this.$attrs.standards.inspectionType
        // orderBy: 'sort',
      })).then(response => {
        this.typeList = response.data || []
      }).catch(() => {

      })
    },
    beforeAdd(params, url) {
      params.inspectionStandardsId = this.$attrs.standards.id
      return params
    }
  }
};
</script>
